import { useMemo } from 'react'
import { aCardsCollapse, useAtomValue } from '~/atoms'
import { useBreakpoint } from '~/hooks'

const DOUBLE_CARDS = 732
const SINGLE_CARDS = 382

export default function useMapCardSizes() {
  const cardsCollapse = useAtomValue(aCardsCollapse)
  const { mdDown, xlDown } = useBreakpoint()

  const sizes = useMemo(() => {
    // Single depreciated and also fixed now
    const single = 484
    if (cardsCollapse === 'none' || mdDown) {
      return { list: 0, single }
    } else if (cardsCollapse === 'single' || xlDown) {
      return { list: SINGLE_CARDS, single }
    }
    return { list: DOUBLE_CARDS, single }
  }, [cardsCollapse, mdDown, xlDown])

  return sizes
}
